import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAutomationTemplateStepHwcCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.HandwrittenCardAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			templateId,
			step,
			beforeId,
			withEmailFallback,
			impersonationContext,
		}: {
			templateId: string;
			beforeId?: string;
			step: Api.HandwrittenCardAutomationStep;
			withEmailFallback: boolean;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/HandwrittenCard`,
					queryParams: {
						beforeId,
						withEmailFallback,
					},
					impersonationContext,
				}),
				'POST',
				step
			);
		},
		onError,
		onSuccess,
	});
}
